import { render, staticRenderFns } from "./dcwjTest.vue?vue&type=template&id=26c8c238&scoped=true"
import script from "./dcwjTest.vue?vue&type=script&lang=js"
export * from "./dcwjTest.vue?vue&type=script&lang=js"
import style0 from "./dcwjTest.vue?vue&type=style&index=0&id=26c8c238&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c8c238",
  null
  
)

export default component.exports